import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ScheduleFragmentDoc } from '../../../../1on1s/graphql/fragment/generated/Schedule';
export type BaseContent_ArticleContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_BaseResourceSchema_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_CheckinType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_CourseContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_ExerciseType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_ExternalContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_ExternalEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_HomeworkType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_KnowledgeAssetContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_LiveEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_MicroLearningContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_OfflineEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_PathContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_QuizContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_RecurringExternalEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_RecurringLiveEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_RecurringOfflineEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type BaseContent_ScormContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, cover?: { url?: string | null } | null };

export type BaseContent_SurveyContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContent_TaskContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type BaseContentFragment = BaseContent_ArticleContentType_Fragment | BaseContent_BaseResourceSchema_Fragment | BaseContent_CheckinType_Fragment | BaseContent_CourseContentType_Fragment | BaseContent_ExerciseType_Fragment | BaseContent_ExternalContentType_Fragment | BaseContent_ExternalEventContentType_Fragment | BaseContent_HomeworkType_Fragment | BaseContent_KnowledgeAssetContentType_Fragment | BaseContent_LiveEventContentType_Fragment | BaseContent_MicroLearningContentType_Fragment | BaseContent_OfflineEventContentType_Fragment | BaseContent_PathContentType_Fragment | BaseContent_QuizContentType_Fragment | BaseContent_RecurringExternalEventContentType_Fragment | BaseContent_RecurringLiveEventContentType_Fragment | BaseContent_RecurringOfflineEventContentType_Fragment | BaseContent_ScormContentType_Fragment | BaseContent_SurveyContentType_Fragment | BaseContent_TaskContentType_Fragment;


export type BaseContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const BaseContentFragmentDoc = /*#__PURE__*/ gql`
    fragment BaseContent on ContentEntity {
  ... on KnowledgeAssetContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on MicroLearningContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on CheckinType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on PathContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on TaskContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on CourseContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on ArticleContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on ExternalContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on ScormContentType {
    id
    name
    type
    duration
    cover {
      url
    }
  }
  ... on ExerciseType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on QuizContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on SurveyContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on BaseResourceSchema {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on HomeworkType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on ScormContentType {
    id
    name
    duration
    type
    cover {
      url
    }
  }
  ... on ExternalEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on ExternalEventType {
        id
        status
        recurringCategory
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
  ... on OfflineEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on OfflineEventType {
        id
        status
        recurringCategory
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
  ... on LiveEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on LiveEventType {
        id
        status
        recurringCategory
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
  ... on RecurringExternalEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on RecurringExternalEventType {
        id
        status
        recurringCategory
        recurrenceSchedule {
          ...Schedule
        }
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
  ... on RecurringOfflineEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on RecurringOfflineEventType {
        id
        status
        recurringCategory
        recurrenceSchedule {
          ...Schedule
        }
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
  ... on RecurringLiveEventContentType {
    id
    name
    duration
    type
    cover {
      url
    }
    event {
      ... on RecurringLiveEventType {
        id
        status
        recurringCategory
        recurrenceSchedule {
          ...Schedule
        }
        prework {
          contents {
            contentId
            isOptional
          }
        }
        postwork {
          contents {
            contentId
            isOptional
          }
        }
        completionSettings {
          considerRecordingProgress
        }
      }
    }
  }
}
    `;